module.exports = __webpack_public_path__ + "img/pctitle1.b1726e4f.png";